export const validCalcTools = [
  'senior-living-cost-calculator',
  'care-quiz',
  'match-with-advisor',
  'compare-price-nearby',
  'neighborhood-insights',
  'get-personalized-list-of-senior-living-options',
] as const;

export const validChecklists = [
  'assisted-living-touring-checklist',
  'independent-living-touring-checklist',
  'memory-care-touring-checklist',
] as const;

export type ValidChecklists = (typeof validChecklists)[number];

export type ValidCalcTools = (typeof validCalcTools)[number];

export function getIsChecklist(
  toolName: ValidChecklists | ValidCalcTools
): toolName is ValidChecklists {
  return validChecklists.includes(toolName as ValidChecklists);
}

export const defaultSearchInsightsFilter = {
  careType: 'assisted-living',
  roomType: 'shared-room',
  include: 'neighborhoodSurvey,county,state',
};
